var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlugHouseholdJSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M31.8662109,15.5l-7.5-13C24.1874771,2.1904297,23.8574219,2,23.5,2h-15C8.1425781,2,7.8124771,2.1904297,7.6337891,2.5 l-7.5,13c-0.1787109,0.3095703-0.1787109,0.6904297,0,1l7.5,13C7.8124771,29.8095703,8.1425781,30,8.5,30h15 c0.3574219,0,0.6874771-0.1904297,0.8662109-0.5l7.5-13C32.0449219,16.1904297,32.0449219,15.8095703,31.8662109,15.5z  M22.9228516,28H9.0771484L2.1542969,16L9.0771484,4h13.8457031l6.9228516,12L22.9228516,28z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5,11c0-1.9296875-1.5703125-3.5-3.5-3.5s-3.5,1.5703125-3.5,3.5s1.5703125,3.5,3.5,3.5S19.5,12.9296875,19.5,11z  M16,12.5c-0.8271484,0-1.5-0.6728516-1.5-1.5s0.6728516-1.5,1.5-1.5s1.5,0.6728516,1.5,1.5S16.8271484,12.5,16,12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5,16C9.5703125,16,8,17.5703125,8,19.5S9.5703125,23,11.5,23s3.5-1.5703125,3.5-3.5S13.4296875,16,11.5,16z M11.5,21 c-0.8271484,0-1.5-0.6728516-1.5-1.5s0.6728516-1.5,1.5-1.5s1.5,0.6728516,1.5,1.5S12.3271484,21,11.5,21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,19.5c0,1.9296875,1.5703125,3.5,3.5,3.5s3.5-1.5703125,3.5-3.5S22.4296875,16,20.5,16S17,17.5703125,17,19.5z M22,19.5 c0,0.8271484-0.6728516,1.5-1.5,1.5S19,20.3271484,19,19.5s0.6728516-1.5,1.5-1.5S22,18.6728516,22,19.5z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlugHouseholdJSmall);
export default __webpack_public_path__ + "static/media/plug-household-j--small.7dbcb201cb7370a7eed18d782c618f4f.svg";
export { ForwardRef as ReactComponent };